import { useTranslation } from "react-i18next";
import { useEditPanelContext } from "./edit_panel_context.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import * as api from "../../../api/apiConnector.js";
import UserContext from "../../../components/User_Context.js";
import { useState, useContext, useEffect } from "react";

function StatusButtons() {
  const { t } = useTranslation("labels");
  const { item , selectedValidation, userRights } = useEditPanelContext();
  const { currentUser  } = useContext(UserContext);
  const [isSavingRightEditModal, setIsSavingRightEditModal] = useState(false);
  const itemStatus = selectedValidation[0]?.Code;

  const [buttonStates, setButtonStates] = useState("DRF")
  const [buttonText, setButtonText] = useState(t("submitForValidation"));

  const [buttonDisabled, setButtonDisabled] = useState(false);


 

  useEffect(() => {
    handleButtonStates();
  }, [itemStatus]);

  const getStatusLabelAndClass = () => {
    switch (buttonStates) {
      case "DRF":
        return { label: t("statusDraft"), badgeClass: "bg-secondary text-white" };
      case "PND":
        return {
          label: t("statusPendingValidation"),
          badgeClass: "text-white",
          style: { backgroundColor: "#FF8C00" }, // deep orange
        };
      case "VLD":
        return { label: t("statusValidatedPendingApproval"), badgeClass: "bg-success text-white", style: { backgroundColor: "#FF8C00" }, };
      case "ACT":
        return { label: t("statusAccepted"), badgeClass: "bg-success text-white" };
      default:
        return { label: t("statusUnknown"), badgeClass: "bg-secondary" };
    }
  };

  const handleButtonStates =  () =>{
    switch(itemStatus){
      case "DRF":
        setButtonStates("DRF");
        setButtonText(t("submitForValidation"));
        setButtonDisabled(false);
        break;
      case "PND":
        setButtonStates("PND");
        setButtonText(t("validationPending"));
        setButtonDisabled(true);
        break;
      case "VLD":
        setButtonStates("VLD");
        setButtonText(t("validated"));
        setButtonDisabled(true);
        break;
      case "ACT":
        setButtonStates("ACT");
        setButtonText(t("active"));
        setButtonDisabled(true);
        break;
  
    }
  }




  const handleStatusUpdate = async (status) =>{
    const body = {
      id: item.item.Id,
      fileStatus: status,
    };

   try{
    const result = await api.sendMessage("dms/updateFileStatus", {
      user: currentUser(),
      body,
    });
    if(result?.success){
      
      handleButtonStates();
      closeOffcanvas();
      withReactContent(Swal).fire({
        title: t("success"),
        icon: "success",
        text:
          t("fileUpdatedSuccessfully", { ns: "labels" }) ||
          "File updated successfully",
        showConfirmButton: true,
        confirmButtonText: t("close"),
      }).then(() => {
        closeOffcanvas();
        window.location.reload();
      });
    } else {
      withReactContent(Swal)
        .fire({
          title: t("error"),
          icon: "error",
          text: t("updateStatusError"),
        });
    }
   } catch (error) {
    console.error(error);
   }
  }

  const closeOffcanvas = () => {
    const closeBtn = document.querySelector("#editPanel .btn-close");
    if (closeBtn) {
      closeBtn.click();
      return;
    }
    const el = document.getElementById("editPanel");
    if (el && window.bootstrap?.Offcanvas) {
      const oc =
        window.bootstrap.Offcanvas.getInstance(el) ||
        new window.bootstrap.Offcanvas(el);
      oc?.hide();
    }
  };

  return (
    <form>
      <div className="pt-3 ">
        {/* Current status badge visible to all rights */}
        {buttonStates !== "DRF" && (
          <div className="mb-2">
            {(() => {
              const { label, badgeClass, style } = getStatusLabelAndClass();
              return (
                <button
                  type="button"
                  className={`btn w-100 rounded-pill ${badgeClass || ""}`}
                  style={style}
                  disabled
                >
                  {t("Status")}: {label}
                </button>
              );
            })()}
          </div>
        )}
        {/* Editor: can undo when PND */}
        {userRights === "editor" && buttonStates === "PND" && (
          <div className="d-flex justify-content-center">
            <button
            className="btn btn-danger light  me-1"
            type="button"
            onClick={() => {
              handleStatusUpdate("DRF");
            }}
          >
            <>
              {t("undoValidation")}           
            </>
          </button>
          </div>
        )}
        {/* Validator/approval: can validate/accept and reject when PND */}
        {userRights && userRights !== "editor" && buttonStates === "PND" && (
          <div className="d-flex justify-content-center">
            <button
              className="btn btn-danger light  me-1"
              type="button"
              onClick={() => {
                handleStatusUpdate("DRF");
              }}
            >
              <>
                {t("reject")}
              </>
            </button>
            <button
              className="btn btn-primary me-1"
              type="button"
              onClick={() => {
                handleStatusUpdate("VLD");
              }}
            >
              <>
                {t("validate")}
              </>
            </button>
          </div>
        )}
        {/* approval: can accept (-> ACT) or reject (-> PND) when VLD */}
        {userRights === "approval" && buttonStates === "VLD" && (
          <div className="d-flex justify-content-center">
            <button
              className="btn btn-danger light  me-1"
              type="button"
              onClick={() => {
                handleStatusUpdate("PND");
              }}
            >
              <>{t("reject")}</>
            </button>
            <button
              className="btn btn-primary me-1"
              type="button"
              onClick={() => {
                handleStatusUpdate("ACT");
              }}
            >
              <>{t("approve")}</>
            </button>
          </div>
        )}
        {/* Submit button visible for editor and approval in DRF */}
        {(userRights === "editor" || userRights === "approval") && buttonStates === "DRF" && (
          <div className="d-flex justify-content-center">
            <button
            id="saveRightEditModal"
            type="button"
            disabled={isSavingRightEditModal || buttonDisabled}
            onClick={async (e) => {
              e.preventDefault();
              setIsSavingRightEditModal(true);
              try {
                await handleStatusUpdate("PND");
              } finally {
                setIsSavingRightEditModal(false);
              }
            }}
            className="btn btn-primary pl-3 "
          >
            {isSavingRightEditModal ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                {/* {t("submit", { ns: "labels" })} */}
                {buttonText}
              </>
            ) : (
              // t("submit", { ns: "labels" })
             <>
              {buttonText}
             </>
            )}
          </button>
          </div>
        )}
      </div>
      
    </form>
  );
}
export default StatusButtons;
